import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext } from "react";
import { WithSearch } from "@elastic/react-search-ui";
import { FormattedMessage, injectIntl } from "react-intl";
import { ReactComponent as RemoveIcon } from "../../../assets/icons/delete.svg";
import { UIStateStoreContext } from "../../../stores/uiStateStore";
/**
 * Renders the 'Clear filters' button.
 */
export const ClearFilters = injectIntl(({ intl }) => {
    const uiStore = useContext(UIStateStoreContext);
    return (_jsx(WithSearch, { mapContextToProps: ({ clearFilters }) => ({ clearFilters }), children: ({ clearFilters }) => {
            function clearAll() {
                if (uiStore.inGlobalSearchMode()) {
                    uiStore.setOpenCategory(undefined);
                }
                uiStore.setOpenCategoryFilters([], true);
                clearFilters();
            }
            return (_jsxs("button", { className: "clear-filters", onClick: clearAll, "data-testid": "clearFiltersButton", children: [_jsx(RemoveIcon, {}), _jsx(FormattedMessage, { id: "actions.clearFilters" })] }));
        } }));
});
